import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';

export interface ConstructionState {
   dashboard: boolean;
}

const ConstructionStore: Module<ConstructionState, StoreState> = {
   namespaced: true,
   state: {
      dashboard: false,
   },

   getters: {},

   mutations: {},
   actions: {},
};

export default ConstructionStore;
